import { render, staticRenderFns } from "./BatchOfRemittanceReversal.vue?vue&type=template&id=b82f531c&scoped=true&"
import script from "./BatchOfRemittanceReversal.vue?vue&type=script&lang=js&"
export * from "./BatchOfRemittanceReversal.vue?vue&type=script&lang=js&"
import style0 from "./BatchOfRemittanceReversal.vue?vue&type=style&index=0&id=b82f531c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82f531c",
  null
  
)

export default component.exports